window.dtScheduleWorkdayReplacement = function () {
  const dt_schedule_workday_replacement = new DataTable('#workday-replacement-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#workday-replacement-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#workday-replacement-datatable', 6); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'desc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "code" },
      { "data": "period" },
      { "data": "employee_fn" },
      { "data": "employee_ln" },

    ],
    columnDefs: [],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
      $('td:eq(4)', row).html(`${data.employee_fn} ${data.employee_ln}`);
      $('td:eq(4)', row).attr('colspan', 2);
      $('td:eq(5)', row).remove()
    },
  });

  dtFinalTouch()
}
